import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const DownloadSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M12.003 1.5C11.4552 1.5 11.0636 1.88112 11.0636 2.42885V15.2033L11.1468 17.7898L7.71471 14.0682L4.60181 10.9833C4.43049 10.8119 4.18063 10.7133 3.92602 10.7133C3.38884 10.7133 3.00875 11.1098 3.00875 11.6364C3.00875 11.9052 3.12155 12.134 3.33397 12.3628L11.2981 20.3339C11.5022 20.5379 11.7473 20.647 12.003 20.647C12.2634 20.647 12.5085 20.5379 12.702 20.3339L20.6709 12.3628C20.8939 12.134 21.0067 11.9052 21.0067 11.6364C21.0067 11.1098 20.616 10.7133 20.0894 10.7133C19.8348 10.7133 19.5849 10.8119 19.4031 10.9833L16.2854 14.0682L12.8638 17.7792L12.9366 15.2033V2.42885C12.9366 1.88112 12.5554 1.5 12.003 1.5ZM3.84442 20.6164C3.30248 20.6164 2.93188 21.0129 2.93188 21.5606C2.93188 22.1083 3.30248 22.5 3.84442 22.5H20.1452C20.6976 22.5 21.0682 22.1083 21.0682 21.5606C21.0682 21.0129 20.6976 20.6164 20.1452 20.6164H3.84442Z"
        fill={color}
      />
    </svg>
  );
};

export { DownloadSvg };
